
import { ProgressBar } from 'react-bootstrap';
import Select from 'react-select';
import request from 'superagent';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class ClioMatterSelector extends Component {
  static defaultProps = {
    connectionId: null,
    clientId: null,
  };

  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    clientId: PropTypes.number,
  };

  state = {
    isLoading: false,
    isRefreshing: false,
  };

  async componentDidMount() {
    const { clientId } = this.props;

    if (clientId)
      await this.loadMatters();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    // if the clientId changed, reload matters
    if (prevProps.clientId !== this.props.clientId) {
      this.setState({ matterOptions: null });
      await this.loadMatters();
    }
  }

  render() {
    const { isLoading, isRefreshing, matterOptions } = this.state;

    if (isLoading && !matterOptions) return (
      <ProgressBar now={100} />
    );

    const refreshClasses = classNames({
      'fa': true,
      'fa-refresh': true,
      'fa-spin': isRefreshing,
    });

    return (
      <div key="self" style={{ position: 'relative' }}>
        <Select
          defaultOptions
          options={matterOptions}
          isClearable
          simpleValue
          key={this.props.clientId}
          disabled={isLoading}
          {...this.props}
        />
        <i className={refreshClasses}
          style={{
            position: 'absolute',
            textAlign: 'center',
            top: '12px',
            right: '27px',
            zIndex: 100,
            cursor: 'pointer',
          }}
          onClick={() => { !isRefreshing && this.loadMatters(true) }}
          key="matter-refresh-button"
        />
      </div>
    );
  }

  async loadMatters(refreshFromClio) {
    const { connectionId, clientId } = this.props;

    if (!clientId || !connectionId)
      return;

    this.setState({
      isLoading: true,
      isRefreshing: refreshFromClio
    });

    const res = await request.get(`/rpc/integrations/connections/${connectionId}/clio/matters?client_id=${clientId}`)
      .query({ refresh: refreshFromClio });

    const matterOptions = this.convertMattersToSelectOptions(res.body.data);

    this.setState({
      isLoading: false,
      isRefreshing: false,
      matterOptions
    });
  }

  convertMattersToSelectOptions(matters) {
    const options = matters.map(
      val => ( { label: this.matterLabel(val), value: val.id } )
    );

    return options;
  }

  matterLabel(matter) {
    return (
      <div>
        <b>{matter.display_number}</b> - {matter.description}
      </div>
    );
  }
};

/**
 * FinalForm compatible field, use like:
 * ```
 * <Field name="matter_id"
 *   component={FinalFormClioMatterSelector}
 *   connectionId={connectionId}
 *   clientId={_.get(values, 'client_id')}
 * />
 * ```
 */
export const FinalFormClioMatterSelector = ({ input: { value, onChange }, ...rest }) => {
  return (
    <ClioMatterSelector
      value={value}
      onChange={selectedOption => onChange(selectedOption)}
      {...rest}
    />
  )
};




// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/Clio/ClioMatterSelector.jsx